import { Settings2 } from 'lucide-react'

interface AdvancedOptionsProps {
    topK: number
    onTopKChange: (val: number) => void
    minScore: number
    onMinScoreChange: (val: number) => void
    model: string
    onModelChange: (val: string) => void
}

export function AdvancedOptions({
    topK,
    onTopKChange,
    minScore,
    onMinScoreChange,
    model,
    onModelChange
}: AdvancedOptionsProps) {
    return (
        <div className="p-4 bg-white/5 border border-white/10 rounded-lg space-y-4">
            <div className="flex items-center gap-2 text-blue-400 mb-2">
                <Settings2 className="w-4 h-4" />
                <h3 className="text-sm font-semibold">Parâmetros de Retrieval</h3>
            </div>

            <div className="grid grid-cols-2 gap-4">
                {/* Top K */}
                <div>
                    <div className="flex justify-between text-xs mb-1">
                        <span className="text-gray-400">Top K</span>
                        <span className="text-white font-mono">{topK}</span>
                    </div>
                    <input
                        type="range"
                        min="1"
                        max="20"
                        value={topK}
                        onChange={(e) => onTopKChange(parseInt(e.target.value))}
                        className="w-full h-1 bg-gray-700 rounded-lg appearance-none cursor-pointer accent-blue-500"
                    />
                </div>

                {/* Min Score */}
                <div>
                    <div className="flex justify-between text-xs mb-1">
                        <span className="text-gray-400">Min Score</span>
                        <span className="text-white font-mono">{minScore.toFixed(2)}</span>
                    </div>
                    <input
                        type="range"
                        min="0"
                        max="1"
                        step="0.05"
                        value={minScore}
                        onChange={(e) => onMinScoreChange(parseFloat(e.target.value))}
                        className="w-full h-1 bg-gray-700 rounded-lg appearance-none cursor-pointer accent-blue-500"
                    />
                </div>
            </div>

            {/* Model Selection */}
            <div>
                <label className="block text-xs font-medium text-gray-400 mb-1">
                    Model LLM
                </label>
                <select
                    value={model}
                    onChange={(e) => onModelChange(e.target.value)}
                    className="w-full px-3 py-2 bg-black/50 border border-white/10 rounded text-sm text-white focus:outline-none focus:border-blue-500"
                >
                    <option value="gpt-4">GPT-4 Turbo</option>
                    <option value="gpt-3.5-turbo">GPT-3.5 Turbo</option>
                    <option value="claude-3-opus">Claude 3 Opus (Simulado)</option>
                </select>
            </div>
        </div>
    )
}
